import imagejScreenshot2 from "./screenshots/imagej-rois.png";
import imagejScreenshot1 from "./screenshots/imagej-run.png";
import imagejScreenshot0 from "./screenshots/imagej-extracted.png";
import screenshot0 from "./screenshots/analysis-groups.jpg";
import screenshot1 from "./screenshots/download-formats.jpg";
import screenshot2 from "./screenshots/download-select.jpg";
import screenshot3 from "./screenshots/gallery-overview.jpg";
import screenshot4 from "./screenshots/gallery-settings.jpg";
import screenshot5 from "./screenshots/guide-overview.jpg";
import screenshot6 from "./screenshots/password-fields.jpg";
import screenshot7 from "./screenshots/polygon-before-after.jpg";
import screenshot8 from "./screenshots/polygon-zoom.jpg";
import screenshot9 from "./screenshots/storage-cards.jpg";
import screenshot10 from "./screenshots/storage-details.jpg";
import screenshot11 from "./screenshots/storage-edit.jpg";

// Local imports ensure the production build includes every illustrated screenshot.
const manualScreenshots = {
  "/manual-assets/imagej-rois.png": imagejScreenshot2,
  "/manual-assets/imagej-run.png": imagejScreenshot1,
  "/manual-assets/imagej-extracted.png": imagejScreenshot0,
  "/manual-assets/web-20261020/analysis-groups.jpg": screenshot0,
  "/manual-assets/analysis-groups.jpg": screenshot0,
  "/manual-assets/web-20261020/download-formats.jpg": screenshot1,
  "/manual-assets/download-formats.jpg": screenshot1,
  "/manual-assets/web-20261020/download-select.jpg": screenshot2,
  "/manual-assets/download-select.jpg": screenshot2,
  "/manual-assets/web-20261020/gallery-overview.jpg": screenshot3,
  "/manual-assets/gallery-overview.jpg": screenshot3,
  "/manual-assets/web-20261020/gallery-settings.jpg": screenshot4,
  "/manual-assets/gallery-settings.jpg": screenshot4,
  "/manual-assets/web-20261020/guide-overview.jpg": screenshot5,
  "/manual-assets/guide-overview.jpg": screenshot5,
  "/manual-assets/web-20261020/password-fields.jpg": screenshot6,
  "/manual-assets/password-fields.jpg": screenshot6,
  "/manual-assets/web-20261020/polygon-before-after.jpg": screenshot7,
  "/manual-assets/polygon-before-after.jpg": screenshot7,
  "/manual-assets/web-20261020/polygon-zoom.jpg": screenshot8,
  "/manual-assets/polygon-zoom.jpg": screenshot8,
  "/manual-assets/web-20261020/storage-cards.jpg": screenshot9,
  "/manual-assets/storage-cards.jpg": screenshot9,
  "/manual-assets/web-20261020/storage-details.jpg": screenshot10,
  "/manual-assets/storage-details.jpg": screenshot10,
  "/manual-assets/web-20261020/storage-edit.jpg": screenshot11,
  "/manual-assets/storage-edit.jpg": screenshot11,
};

export default manualScreenshots;
